import { render, staticRenderFns } from "./ObjectCreate.vue?vue&type=template&id=2d7b3a0e&scoped=true&"
import script from "./ObjectCreate.vue?vue&type=script&lang=js&"
export * from "./ObjectCreate.vue?vue&type=script&lang=js&"
import style0 from "./ObjectCreate.vue?vue&type=style&index=0&id=2d7b3a0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d7b3a0e",
  null
  
)

export default component.exports